import { createFileRoute } from "@tanstack/react-router";
import { Chip, Table } from "@heroui/react";

import {
  TariffCategoryEntity,
  useTariffCategories,
} from "@/features/tariffs/use-tariffs.ts";
import { CreateTariffCategoryModal } from "@/features/tariffs/categories/ui/create-tariff-category-modal.tsx";
import { TariffCategoryTableOptions } from "@/features/tariffs/categories/ui/tariff-category-table-options.tsx";

export const Route = createFileRoute("/dashboard/categories/")({
  component: RouteComponent,
});

function RouteComponent() {
  const tariffCategories = useTariffCategories();

  return (
    <div className="flex flex-col pt-4 pr-4">
      <div className="flex flex-row gap-2 justify-between h-12 items-center">
        <p className="font-bold text-xl">Категории тарифов</p>

        <CreateTariffCategoryModal />
      </div>

      <Table.Root className="mt-8">
        <Table.Content aria-label="Категории тарифов">
          <Table.Header>
            <Table.Column>ID</Table.Column>
            <Table.Column>Название</Table.Column>
            <Table.Column>Ключ</Table.Column>
            <Table.Column>Тарифов</Table.Column>
            <Table.Column>Видимость</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={tariffCategories.data.data}>
            {(category: TariffCategoryEntity) => (
              <Table.Row id={String(category.id)}>
                <Table.Cell>{category.id}</Table.Cell>
                <Table.Cell>{category.name}</Table.Cell>
                <Table.Cell>{category.key}</Table.Cell>
                <Table.Cell>{category.tariffs.length}</Table.Cell>
                <Table.Cell>
                  {category.active ? (
                    <Chip color="success" variant="soft">
                      Видимый
                    </Chip>
                  ) : (
                    <Chip color="danger" variant="soft">
                      Не видимый
                    </Chip>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <TariffCategoryTableOptions tariffCategory={category} />
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </div>
  );
}
